export enum SelectorUniverseEnum {
    CONTRACT = 'selecteur_contrat',
    USAGE = 'selecteur_usage',
}
